import React, {Fragment,useState, useEffect } from 'react';
import { withRouter } from "react-router-dom";
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { Typeahead } from 'react-bootstrap-typeahead';
import XLSX from 'xlsx';
import gql from 'graphql-tag';
import moment from 'moment';
import PageTitle from '../../Layout/AppMain/PageTitle';
import * as FileSaver from 'file-saver';

import { useLazyQuery, useMutation, useQuery } from '@apollo/react-hooks';
import {
    Nav, NavItem, NavLink, Modal, ModalHeader, ModalBody, ModalFooter,Progress,FormFeedback,
    InputGroup, FormGroup, Label, Input, ButtonToggle, Spinner, UncontrolledTooltip, TabContent, TabPane
  } from 'reactstrap';

import {
    Col,CardTitle,
    Card,Form, FormText ,
    CardBody, Button, InputGroupAddon
  } from 'reactstrap';

  //Get Inspections for a given PO,Part, Doc Version
const GET_INSPECTIONS = gql`
query getInspections($PONum: String, $PartNum: String, $AgileDocIDVer: String){
  SupplierFileHeader(filters: {
    PONum: $PONum
    PartNum: $PartNum
    AgileDocIDVer: $AgileDocIDVer
}) {
edges {
 node {
   PartNum
   AgileDocIDVer
   MasterLotQty
   PONum
   Status
   FileGUID
   UpdateTS
   MasterLotNum
   mstrLotCompletionDate
 }
}
}
}

`;

  //Get List of Open PO for the vendor Config
const GET_OPEN_PO = gql`
query getOpenPO($VendorNum: String, $OpenPOFlag:String){
  SupplierPO(filters: {
     VendorNum:$VendorNum
     OpenPOFlag: $OpenPOFlag
}) {
edges {
 node {
   PONum
   MaterialNum
   MaterialRev
   POQty 
   RcvdQty
 }
}
}
}
`;

//Get Plan Details by Part Number and Revision
const GET_PLAN_DETAILS = gql`
      query getPlanDetails($PartNum: String, $PartRev: String){
        PlanDetails(filters: {
           PartNum:$PartNum,
           PartRev:$PartRev
    },sort:COL_SL_NUM_ASC) {
     edges {
       node {
         PlanID
         PartNum
         PartDesc
         PartRev
         SpecId
         Label
         LabelNum
         Method
         LSL
         USL
         SpecDataType
         Precision
         ColIndex
         ColSlNum
         Sampling
         AQL
         Characteristic
         SpecType
         SpecVal
         SpecValMin
         SpecValMax
         SpecValTOLPlus
         SpecValTOLMinus
         BonusTOL
         NumPlaces
         BaloonNum
         SheetNum
       }
     }
    }
  }
`;


  const TemplateDownload = ({ history }) => {
    const [planDetails, setPlanDetails] = useState(null);
    const [header, setHeader] = useState(null);
    const [details, setDetails] = useState(null);
    const [submitEnabled, setSubmitEnabled] = useState(false);
    const [reportMode, setReportMode] = useState("");
    const [reportFileGUID, setReportFileGUID] = useState(null);

  
    const [packingSlip, setPackingSlip] = useState(null);
    const [PONum, setPONum] = useState(null);
    const [PartNum, setPartNum] = useState(null);
    const [AgileDocIDVer, setAgileDocIDVer] = useState(null);
    const [MasterLotNum, setMasterLotNum] = useState(null);
    const [mstrLotCompletionDate, setMstrLotCompletionDate] = useState(null);
    const [MasterLotQty, setMasterLotQty] = useState(null);
    const [SubLotNum, setSubLotNum] = useState(null);
    const [SubLotQty, setSubLotQty] = useState(null);
    const [sampleUnits, setSampleUnits] = useState(null);
    const [openPO, setOpenPO] = useState('');
    const [selectedPO, setSelectedPO] = useState(null);
    const [POMaterial, setPOMaterial] = useState([]);
    const [MaterialRev, setMaterialRev] = useState([]);
    const [newreportBtn, setNewReportBtn] = useState(false);
    const [showSaveConfirmation, setShowSaveConfirmation] = useState(false);
    const [showSubmitConfirmation, setShowSubmitConfirmation] = useState(false);
    const [showLoading, setShowLoading] = useState(null);
    const [, setValidationData] = useState(null);
    const [showFinalReport, setShowFinalReport] = useState(false);
    const Datetime = require('react-datetime');
    const [mandatorValidation, setMandatoryValidation] = useState(null);
    const [inspections, setInspections] = useState(null);
    const [masterQtyDisable, setMasterQtyDisable] = useState(false);
    const [activeTab, setActiveTab] = useState('1');
    const [showPlanDoesNotExist, setShowPlanDoesNotExist] = useState(null);
    const [, setShowDashboard] = useState(null);
    const [, setChart1Options] = useState([]);
    const [] = useState(null);
    const [timeOrdered, setTimeOrdered] = useState(false);
    const [partialShipment, setPartialShipment] = useState(true);
    const [measurementsExist, setMeasurementsExist] = useState(true);
    const [certFiles, setCertFiles] = useState(null);
    const [certsArray, setCertsArray] = useState(null);
    const [certificates, setCertificates] = useState(null);
    const [showFileUpload, setShowFileUpload] = useState(false);
    const [subgroupSize, setSubGroupSize] = useState(null);
    const [subgroupsizeText, setSubgroupsizeText] = useState(null);
    const [subgroupSizeValidated, setSubGroupSizeValidated] = useState(false);
    const [unitsValidated, setUnitsValidated] = useState(false);
    const [showMasterLotQtyError, setShowMasterLotQtyError] = useState(false);
    const [sampleTimeValidated, setSampleTimeValidated] = useState(false);
    const [partDesc, setPartDesc] = useState(null);
    // const SweetAlert = withSwalInstance(swal);
    const [showReset, setShowReset] = useState(false);

    const { data } = useQuery(GET_OPEN_PO, {
        fetchPolicy: 'no-cache',
        variables: { VendorNum: localStorage.getItem('loggedInVendor'), 'OpenPOFlag': '1' }
      });

      //Get Inspections
  const [getInspections] = useLazyQuery(GET_INSPECTIONS, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      setInspections(data.SupplierFileHeader.edges);

    }
  });

  //Get Plan details call
  const [getPlanDetailsData] = useLazyQuery(GET_PLAN_DETAILS, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      if (data.PlanDetails.edges.length > 0) {
        setPlanDetails(data.PlanDetails.edges);
        setShowPlanDoesNotExist(false);
        setPartDesc(data.PlanDetails.edges[0].node.PartDesc);
        } else {
            setShowPlanDoesNotExist(true);
        }
      
    }
  });

  const compleationDateValidation = (currentDate) => {
    return currentDate.isBefore(moment());
}

 //method to validate master lot completion date
 const changeMstrLotCompletionDate = (e) => {
    //console.log(e);
    try {
      if (e.diff(new Date()) <= 0) {
        let tdate = e.format('MM/DD/YYYY');
        ////console.log(new Date(tdate));
          
        setMstrLotCompletionDate(new Date(tdate).toLocaleDateString());
        validateInputParams();
      } else {
        //  e.preventDefault();
        setMstrLotCompletionDate(null);
       
        return false;
      }
    } catch (er) {
      //console.log(er);
      validateInputParams();
      return false;
    }
  }

  const checkMasterLot = (masterLot) => {
    
    if (inspections) {
      
      const checkInspections = inspections.filter(inspections => inspections.node.MasterLotNum.toUpperCase() == masterLot.toUpperCase());
      ////console.log(checkInspections);
      if (checkInspections.length > 0) {
        setMasterQtyDisable(true);
        // ////console.log(new Date(checkInspections[0].node.mstrLotCompletionDate));
        setMstrLotCompletionDate(checkInspections[0].node.mstrLotCompletionDate);
        setMasterLotQty(checkInspections[0].node.MasterLotQty);
      
        setMeasurementsExist(false);
       
      } else {
        setMasterLotQty(0);
        setMasterQtyDisable(false);
        setMeasurementsExist(true);
       
      }
    }
  }

  const downloadTemplate = () => {
    // if (PONum && AgileDocIDVer && PartNum && MasterLotNum && MasterLotNum && SubLotNum && SubLotQty && sampleUnits && sampleUnits && mstrLotCompletionDate) {
    if (newreportBtn) {
      setShowLoading(true);
      let headerObject = {};
      headerObject['PartNum'] = (PartNum?PartNum:'');
      headerObject['AgileDocIDVer'] = (AgileDocIDVer?AgileDocIDVer:'');
      headerObject['PONum'] = (PONum?PONum:'');
      headerObject['MasterLotNum'] = (MasterLotNum?MasterLotNum:'');
      headerObject['MasterLotQty'] = (MasterLotQty?MasterLotQty:'');
      headerObject['SubLotNum'] = (SubLotNum?SubLotNum:'');
      headerObject['SubLotQty'] = (SubLotQty?SubLotQty:'');
      headerObject['partDesc'] = (partDesc?partDesc:'');
      headerObject['sampleUnits'] = (sampleUnits?sampleUnits:'');
      headerObject['Program'] = (subgroupSize?subgroupSize:'');
      headerObject['mstrLotCompletionDate'] = (mstrLotCompletionDate?mstrLotCompletionDate:'');
      headerObject['PackingSlipNum'] = (packingSlip?packingSlip:'');
      headerObject['timeOrdered'] = (timeOrdered?timeOrdered:false);
      headerObject['subgroupSize'] = (subgroupSize?subgroupSize:'');
      setHeader(headerObject);
      generateTemplate(headerObject);
    //console.log(headerObject);


    }
  }

   //Delete loaded certificates function
  //This functions makes an API call to delete the file from DB as well as S3 Bucket
  const generateTemplate = (header) => {
    setShowLoading(true);
    const token = JSON.parse(localStorage.getItem('okta-token-storage')).accessToken.accessToken;
    let url = window.location.origin + '/download_template';
    if (window.location.hostname == 'localhost') {
      url = 'http://' + window.location.hostname + ':5000/download_template';
    }

  
    fetch(url, {
        method: 'POST',
        body: JSON.stringify({ header: header}),
        headers: {
          'Content-Type': 'application/json',
          'responseType': 'application/octet-stream',
          'authorization': token || null,
          'authVendorID': localStorage.getItem('loggedInVendor')
        }
      }).then(res => res.blob())
        .then(blob => {
          FileSaver.saveAs(blob, 'plan_template_' + header['PartNum'] + "-" + header['AgileDocIDVer'] + '.xlsx');
          setShowLoading(false);
        }).catch(err => alert('Unable to download data'));
  
    }
  

  

  const onChangeMaterial = (MaterialNum) => {
    let t_material_rev = [];
    let t_openPO = [];
    if (MaterialNum.length > 0) {
      setPartNum(MaterialNum[0].MaterialNum);
      data.SupplierPO.edges.map((el) => {
        if (el.node.MaterialNum == MaterialNum[0].MaterialNum) {
          //  const checkPO = t_openPO.filter(po => po.PONum == el.node.PONum);
          
          const checkRev = t_material_rev.filter(rev => (el.node.MaterialRev == rev.MaterialRev));
          // if (checkPO.length == 0) {
            // t_openPO.push({ PONum: el.node.PONum });
          // }
          if (checkRev.length == 0) {
            if (PONum) {
                if (el.node.PONum == PONum) {
                  t_material_rev.push({ MaterialRev: el.node.MaterialRev });
                }
            } else {
              
            t_material_rev.push({ MaterialRev: el.node.MaterialRev });
            }
          }
        }
      });
      validateInputParams();
      setMaterialRev(t_material_rev);
      // setOpenPO(t_openPO);
      // //console.log(setMaterialOpenPO);
      // setMaterialOpenPO(t_openPO);
    } else {
      data.SupplierPO.edges.map((el) => {
        const checkPO = t_openPO.filter(po => po.PONum == el.node.PONum);
        if (checkPO.length == 0) {
          t_openPO.push({ PONum: el.node.PONum });
        }
      });
      setOpenPO(t_openPO);
    }
  }

  const MaterialRevChange = (MaterialRev) => {
    if (MaterialRev.length > 0) {
      let t_openPO = [];
      data.SupplierPO.edges.map((el) => {
        if (el.node.MaterialNum == PartNum && el.node.MaterialRev == MaterialRev[0].MaterialRev) {
          const checkPO = t_openPO.filter(po => po.PONum == el.node.PONum);
                    if (checkPO.length == 0) {
            t_openPO.push({ PONum: el.node.PONum });
          }
      
        }
      });
      setMandatoryValidation(true);
      setAgileDocIDVer(MaterialRev[0].MaterialRev);
      validatePlan(MaterialRev[0].MaterialRev);
      validateInputParams();
    }
  }


      const checkInspections = (ver) => {
        getInspections({
          variables: { PONum: PONum, PartNum: PartNum, AgileDocIDVer: ver }
        });
    
      }

      const validatePlan = (docVer) => {
        getPlanDetailsData({
          variables: {
            PartNum: PartNum,
            PartRev: docVer
    
          }
        });
      }

      //Event to get PO Details
  useEffect(() => {
    if (data) {
      let t_openPO = [];
      let t_material = [];
      data.SupplierPO.edges.map((el) => {
        const checkPO = t_openPO.filter(po => po.PONum == el.node.PONum);
        const checkMaterial = t_material.filter(material => material.MaterialNum == el.node.MaterialNum);
        // ////console.log(checkPO);
        if (checkPO.length == 0) {
          t_openPO.push({ PONum: el.node.PONum });
        }

        if (checkMaterial.length == 0) {
          t_material.push({ MaterialNum: el.node.MaterialNum });
        }
      });
      setOpenPO(t_openPO);
      setPOMaterial(t_material);
    }
  }, [data]);

  useEffect(() => { 
    if (AgileDocIDVer && PartNum ) {
         setNewReportBtn(true);
       }

  },[AgileDocIDVer,PartNum]);


      const validateInputParams = () => {
        if (document.getElementById('NewReportBtn')) {
          if (showPlanDoesNotExist) {
            document.getElementById('NewReportBtn').style.display = 'none';
          }
          else {
            document.getElementById('NewReportBtn').style.display = 'block';
          }
        }
        //console.log(PONum + '----' + AgileDocIDVer + '----' +  PartNum);
        if (AgileDocIDVer && PartNum) {
       
          setNewReportBtn(true);
          
        }
      }

    return (
    <Fragment>
  


    <ReactCSSTransitionGroup
      component="div"
      transitionName="TabsAnimation"
      transitionAppear={true}
      transitionAppearTimeout={0}
      transitionEnter={false}
      transitionLeave={false}>


        <div style={{ marginLeft: '2%', marginRight: '2%' }}>
       <PageTitle 
          heading="Generate Plan Templates"
          icon="pe-7s-keypad icon-gradient bg-mean-fruit"
        /></div> 
          {(data && openPO)?
            <Card className="main-card mb-3" style={{ margin: '10px' }}>
                <CardBody>

                  <Form>
                    <FormGroup row>
                    
                      <Col sm={2}>
                        <Label className="control-label required" for="PartNum">Material Number</Label>

                        <Typeahead
                          id="PartNum"
                          labelKey="MaterialNum"
                          valueKey="MaterialNum"
                          onChange={onChangeMaterial}
                          options={POMaterial}
                          placeholder="Please select Material..."

                        />



                      </Col>
                      <Col sm={2}>
                        <Label className="control-label required" for="AgileDocIDVer">Agile Doc ID / Rev</Label>
                        <Typeahead
                          id="AgileDocIDVer"
                          labelKey="MaterialRev"
                          valueKey="MaterialRev"
                          onChange={MaterialRevChange}
                          options={MaterialRev}
                          placeholder="Please select Material..."

                        />

                        {/* <Input type="select" id='AgileDocIDVer' disabled={(reportMode == 'Draft' ||reportMode == 'Submitted' || reportMode == 'Processed') ? true : false} value={AgileDocIDVer} onChange={e => { validatePlan(); setMandatoryValidation(true); setAgileDocIDVer(e.target.value); checkInspections(e.target.value); validateInputParams(); }}>
                      <option value=''>Please select Revision</option>
                      {MaterialRevSelect}

                    </Input> */}

                      </Col>

                     
                    </FormGroup>
                 

                 
                    <ButtonToggle id='NewReportBtn' onClick={downloadTemplate} color="primary" disabled={!newreportBtn ? true : false} >Download</ButtonToggle>

                    </Form>
                    {(showPlanDoesNotExist) ? <div style={{ textAlign: 'center', color: 'red', fontWeight: 'bold' }}> There is no inspection plan available for the selected Part Number and Revision</div> : null}

                    </CardBody>
                    </Card>: null}

                    <Modal isOpen={showLoading} toggle={showLoading}>
                      <div style={{ width: '100%', textAlign: "center", marginTop: '20px', verticalAlign: 'center' }}>
                        <div class="spinner-border m-5" role="status">
                          <span class="sr-only">Downloading...</span>
                        </div>
                        <div style={{ width: '100%', textAlign: "center", fontSize: '20px' }}> Downloading Plan Template ... </div>
                      </div> </Modal>
      </ReactCSSTransitionGroup>
        </Fragment>

        )

  }

  export default (withRouter(TemplateDownload))
